module.exports = Studio.libraries['react'];


/*****************
 ** WEBPACK FOOTER
 ** external "Studio.libraries['react']"
 ** module id = 3
 ** module chunks = 0
 **/